// src/pages/SinConexion.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import './SinConexion.css';

const SinConexion = () => {
  const [contador, setContador] = useState(3);
  const [intentos, setIntentos] = useState(0);
  const navigate = useNavigate();

  // Función para verificar la conexión - intentando cargar la página anterior
  const verificarConexion = () => {
    const rutaPrevia = sessionStorage.getItem('rutaPreviaSinConexion');
    
    if (rutaPrevia && rutaPrevia !== '/sin-conexion') {
      // Intentamos navegar a la página anterior
      window.location.href = rutaPrevia;
    } else {
      // Si no hay ruta previa, vamos al inicio
      window.location.href = '/';
    }
  };

  useEffect(() => {
    let intervalo;
    
    intervalo = setInterval(() => {
      if (contador > 0) {
        setContador(contador - 1);
      } else {
        // Cuando el contador llega a 0, intentamos verificar conexión
        verificarConexion();
        setContador(3); // Reiniciamos contador
        setIntentos(intentos + 1);
      }
    }, 1000);

    return () => {
      if (intervalo) clearInterval(intervalo);
    };
  }, [contador, intentos]);

  const reintentarManual = () => {
    setContador(0); // Forzar verificación inmediata
  };

  const volverInicio = () => {
    sessionStorage.removeItem('rutaPreviaSinConexion');
    navigate('/');
  };

  return (
    <div className="sin-conexion-container">
      <div className="sin-conexion-content">
        <motion.div
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.5 }}
          className="sin-conexion-icon"
        >
          <svg width="100" height="100" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L23 23" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M16.72 11.96C17.54 11.22 18 10.16 18 9C18 6.79 16.21 5 14 5C12.95 5 12 5.37 11.25 5.96" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M2.81 7.79C1.29 9.29 0.5 11.3 0.5 13.5C0.5 17.08 3.42 20 7 20C9.19 20 11.13 18.91 12.37 17.3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M8.5 13.5C8.5 15.43 10.07 17 12 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M21.5 6.5C22.98 8.02 23.5 9.93 23.5 12C23.5 15.5 21 18.5 17.5 19.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            <path d="M10.5 6.5C11.23 5.91 12.08 5.5 13 5.5C15.21 5.5 17 7.29 17 9.5C17 10.32 16.75 11.08 16.33 11.7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
        </motion.div>

        <h1>Sin conexión al servidor</h1>
        
        <p>No podemos establecer conexión con el servidor en este momento.</p>
        
        <div className="reintento-contenedor">
          <p>Intentando reconectar en: {contador}</p>
          <div className="spinner"></div>
          <p className="intentos">Intentos: {intentos}</p>
        </div>

        <div className="botones-contenedor">
          <button 
            className="btn-reintentar"
            onClick={reintentarManual}
          >
            Reintentar ahora
          </button>
          
          <button 
            className="btn-inicio"
            onClick={volverInicio}
          >
            Volver al inicio
          </button>
        </div>
        
        <div className="consejos">
          <h3>¿Qué puedes hacer?</h3>
          <ol>
            <li>Verificar tu conexión a Internet</li>
            <li>Contactar al administrador del sistema</li>
            <li>Revisar si el servidor está en ejecución</li>
            <li>Esperar unos minutos e intentar nuevamente</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default SinConexion;